import _ from 'lodash';
import React from 'react';
import { Modal } from 'semantic-ui-react'
import closeIcon from '../../../assets/images/newui/close.png'
import "./RequestInvoiceDetailModal.less"
import RequestInvoiceDetail from '../RequestInvoiceDetail/RequestInvoiceDetail';

function RequestInvoiceDetailModal({isOpen, onClose, selectedRequest, onCustomerNameChangeSubmit, onInvoiceItemsUpdate}) {
 
return (
    <Modal
      open={isOpen}
      closeOnDimmerClick={false}
      onClose={() => onClose()}
      className="request-invoice-detail-modal"
    >
        <div className="close-button"
            onClick={() => onClose()}>
            <img src={closeIcon}></img>
        </div>
        <RequestInvoiceDetail
          onInvoiceItemsUpdate={() => onInvoiceItemsUpdate()}
          scRequestID={selectedRequest.scRequestID}  
          onCustomerNameChangeSubmit={() => onCustomerNameChangeSubmit()}/>
    </Modal>
  );
}


export default RequestInvoiceDetailModal